

export function splitSentence(sentence: string, conjunctions: string[] = ["and"]): string[] {
  // Split the sentence by commas
  let items = sentence.split(',');

  // Check if the last item contains the conjunction
  const lastItem = items[items.length - 1];
  for (let conjunction of conjunctions) {
    const conjunctionIndex = lastItem.toLowerCase().indexOf(conjunction.toLowerCase());

    if (conjunctionIndex !== -1) {
        // Split the last item by the conjunction
        const lastItems = lastItem.split(" " + conjunction + " ");
        // Trim whitespace from each part
        const trimmedLastItems = lastItems.map(item => item.trim());

        // Replace the last item with the split parts
        items = items.slice(0, -1).concat(trimmedLastItems);
    }
  }

  return items.map(item => item.trim()).filter((item) => !!item);
}

export function combineSentence(items: string[], conjunction: string, allowOxfordComma: boolean = true) {
  if (items.length === 0) {
    return "";
  }
  if (items.length === 1) {
    return items[0];
  }
  if (items.length === 2) {
    return items[0] + " " + conjunction + " " + items[1];
  }
  return items.slice(0, -1).join(", ") + (allowOxfordComma ? ", " : " ") + conjunction + " " + items.slice(-1);
}